type NavRecord = {
  stack: string
  action: 'push' | 'replace'
  at: number
}

let lastNavRecord: NavRecord | null = null

export function getLastNavRecord(maxAgeMs = 1000): NavRecord | null {
  if (!lastNavRecord) return null
  if (Date.now() - lastNavRecord.at > maxAgeMs) return null
  return lastNavRecord
}

export function mountHistoryInterceptor(): () => void {
  const origPush = history.pushState.bind(history)
  const origReplace = history.replaceState.bind(history)

  history.pushState = function (
    data: unknown,
    unused: string,
    url?: string | URL | null
  ) {
    lastNavRecord = {
      stack: new Error().stack ?? '',
      action: 'push',
      at: Date.now()
    }
    return origPush(data, unused, url ?? null)
  }

  history.replaceState = function (
    data: unknown,
    unused: string,
    url?: string | URL | null
  ) {
    lastNavRecord = {
      stack: new Error().stack ?? '',
      action: 'replace',
      at: Date.now()
    }
    return origReplace(data, unused, url ?? null)
  }

  return () => {
    history.pushState = origPush
    history.replaceState = origReplace
    lastNavRecord = null
  }
}
